/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/trialbalance.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./trialbalance_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.TrialBalanceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.TrialBalanceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListTrialBalanceRequest,
 *   !proto.reportpb.ListTrialBalanceResponse>}
 */
const methodDescriptor_TrialBalanceService_ListTrialBalance = new grpc.web.MethodDescriptor(
  '/reportpb.TrialBalanceService/ListTrialBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListTrialBalanceRequest,
  proto.reportpb.ListTrialBalanceResponse,
  /**
   * @param {!proto.reportpb.ListTrialBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListTrialBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListTrialBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListTrialBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.TrialBalanceServiceClient.prototype.listTrialBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListTrialBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListTrialBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.TrialBalanceServicePromiseClient.prototype.listTrialBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListTrialBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListJTOTrialBalanceRequest,
 *   !proto.reportpb.ListJTOTrialBalanceResponse>}
 */
const methodDescriptor_TrialBalanceService_ListJTOTrialBalance = new grpc.web.MethodDescriptor(
  '/reportpb.TrialBalanceService/ListJTOTrialBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListJTOTrialBalanceRequest,
  proto.reportpb.ListJTOTrialBalanceResponse,
  /**
   * @param {!proto.reportpb.ListJTOTrialBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListJTOTrialBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListJTOTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListJTOTrialBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListJTOTrialBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.TrialBalanceServiceClient.prototype.listJTOTrialBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListJTOTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListJTOTrialBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListJTOTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListJTOTrialBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.TrialBalanceServicePromiseClient.prototype.listJTOTrialBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListJTOTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListJTOTrialBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListCustomerReserveTrialBalanceRequest,
 *   !proto.reportpb.ListCustomerReserveTrialBalanceResponse>}
 */
const methodDescriptor_TrialBalanceService_ListCustomerReserveTrialBalance = new grpc.web.MethodDescriptor(
  '/reportpb.TrialBalanceService/ListCustomerReserveTrialBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListCustomerReserveTrialBalanceRequest,
  proto.reportpb.ListCustomerReserveTrialBalanceResponse,
  /**
   * @param {!proto.reportpb.ListCustomerReserveTrialBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListCustomerReserveTrialBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListCustomerReserveTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListCustomerReserveTrialBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListCustomerReserveTrialBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.TrialBalanceServiceClient.prototype.listCustomerReserveTrialBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListCustomerReserveTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListCustomerReserveTrialBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListCustomerReserveTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListCustomerReserveTrialBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.TrialBalanceServicePromiseClient.prototype.listCustomerReserveTrialBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListCustomerReserveTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListCustomerReserveTrialBalance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListAlpacaDBClientTrialBalanceRequest,
 *   !proto.reportpb.ListAlpacaDBClientTrialBalanceResponse>}
 */
const methodDescriptor_TrialBalanceService_ListAlpacaDBClientTrialBalance = new grpc.web.MethodDescriptor(
  '/reportpb.TrialBalanceService/ListAlpacaDBClientTrialBalance',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListAlpacaDBClientTrialBalanceRequest,
  proto.reportpb.ListAlpacaDBClientTrialBalanceResponse,
  /**
   * @param {!proto.reportpb.ListAlpacaDBClientTrialBalanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListAlpacaDBClientTrialBalanceResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListAlpacaDBClientTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListAlpacaDBClientTrialBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListAlpacaDBClientTrialBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.TrialBalanceServiceClient.prototype.listAlpacaDBClientTrialBalance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListAlpacaDBClientTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListAlpacaDBClientTrialBalance,
      callback);
};


/**
 * @param {!proto.reportpb.ListAlpacaDBClientTrialBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListAlpacaDBClientTrialBalanceResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.TrialBalanceServicePromiseClient.prototype.listAlpacaDBClientTrialBalance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.TrialBalanceService/ListAlpacaDBClientTrialBalance',
      request,
      metadata || {},
      methodDescriptor_TrialBalanceService_ListAlpacaDBClientTrialBalance);
};


module.exports = proto.reportpb;

